import React, { useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import BarChartContent from '@components/pages/Dashboard/BarChartContent.component'
import BarChart from '@components/pages/Dashboard/Charts/BarChart.component'
import DashboardCard from '@components/pages/Dashboard/DasboardCard.component'
import DashboardCalendar from '@components/pages/Dashboard/DashboardCalendar.component'
import BarChartLine from '@components/pages/Dashboard/Charts/BarLineChart.component'
import ProgressBarCardContent from '@components/pages/Dashboard/PerformanceBoardPage/ProgressBarCardContent.component'
import CardContainer from '@components/pages/Dashboard/CollectionsBoard/CardContainer.component'

import {
  ARAging,
  ARAgingLegend,
  ClaimsAging,
  ClaimsAgingLegend,
  ClaimsAgingLineData,
  annualPatientValue,
  arDaysCollection,
  arRatio,
  collectionsData,
  collectionsLegend,
  ninetyDayCollection,
  ninetyDayCollectionPercent,
  seriesNamesLineClaimsAging,
} from '@components/pages/Dashboard/DashboardMockData'
import { ARAgingModal } from '@components/layout/Modals'

function CollectionsBoard(): React.ReactElement {
  const [arAgingModalIsOpen, setArAgingModalIsOpen] = useState(false)

  const toggleARAgingModal = (): void =>
    setArAgingModalIsOpen(!arAgingModalIsOpen)

  return (
    <>
      <Row className="mt-3">
        <Col md={4}></Col>
        <Col md={4} className="text-center">
          <DashboardCalendar />
        </Col>
        <Col md={4}></Col>
      </Row>
      <Row className="mt-5">
        <Col md={4}>
          <DashboardCard
            title={'AR Aging'}
            body={
              <BarChartContent
                chart={
                  <BarChart
                    title={'AR Aging'}
                    isTransposed={true}
                    data={ARAging}
                    primaryYAxis={{
                      minimum: 50000,
                      maximum: 300000,
                      interval: 50000,
                    }}
                    onClick={toggleARAgingModal}
                  />
                }
                icon={'fa fa-caret-up'}
                displayActual={true}
                legendData={ARAgingLegend}
                classNameCol="col-md-4"
              />
            }
            classNameCard="h-100"
            iconPrimary={'bi bi-bar-chart-fill'}
            iconSecondary={'bi bi-search'}
            trendDirection="up"
          />
        </Col>
        <Col md={4}>
          <DashboardCard
            title={'Claims Aging'}
            body={
              <BarChartContent
                chart={
                  <BarChartLine
                    title={'Claims Aging'}
                    isTransposed={true}
                    data={ClaimsAging}
                    primaryYAxis={{
                      minimum: 50000,
                      maximum: 300000,
                      interval: 50000,
                    }}
                    lineData={ClaimsAgingLineData}
                    lineSeriesNames={seriesNamesLineClaimsAging}
                  />
                }
                icon={'fa fa-caret-up'}
                displayActual={true}
                legendData={ClaimsAgingLegend}
                classNameCol="col-md-3"
              />
            }
            classNameCard="h-100"
            iconPrimary={'bi bi-bar-chart-fill'}
            iconSecondary={'bi bi-search'}
            trendDirection="up"
          />
        </Col>
        <Col md={4}>
          <DashboardCard
            title={'Annual Patient Value'}
            body={
              <CardContainer displayTwoText={false} data={annualPatientValue} />
            }
            classNameCard="h-100"
            iconPrimary={'bi bi-bar-chart-fill'}
            iconSecondary={'bi bi-search'}
            trendDirection="up"
          />
        </Col>
      </Row>
      <Row className="mt-5">
        <Col md={3}>
          <DashboardCard
            title={'Collections'}
            body={
              <ProgressBarCardContent
                title={'No-Shows'}
                progLabel={'Goal'}
                progUnit={'$'}
                legendData={collectionsLegend}
                classNameCol={'col-md-4'}
                data={collectionsData}
                displayPercent={false}
              />
            }
            iconPrimary={'bi bi-bar-chart-fill'}
            iconSecondary={'bi bi-search'}
            classNameCard="h-100"
            trendDirection="up"
          />
        </Col>
        <Col md={3}>
          <DashboardCard
            title={'90 Day Collection %'}
            body={
              <CardContainer
                displayTwoText={true}
                data={ninetyDayCollectionPercent}
                legendData={ninetyDayCollection}
              />
            }
            classNameCard="h-100"
            iconPrimary={'bi bi-bar-chart-fill'}
            iconSecondary={'bi bi-search'}
            trendDirection="up"
          />
        </Col>
        <Col md={3}>
          <DashboardCard
            title={'AR Days'}
            body={
              <CardContainer displayTwoText={false} data={arDaysCollection} />
            }
            classNameCard="h-100"
            iconPrimary={'bi bi-bar-chart-fill'}
            iconSecondary={'bi bi-search'}
            trendDirection="up"
          />
        </Col>
        <Col md={3}>
          <DashboardCard
            title={'AR Ratio'}
            body={<CardContainer displayTwoText={false} data={arRatio} />}
            classNameCard="h-100"
            iconPrimary={'bi bi-bar-chart-fill'}
            iconSecondary={'bi bi-search'}
            trendDirection="up"
          />
        </Col>
      </Row>
      <ARAgingModal
        isOpen={arAgingModalIsOpen}
        toggleModal={toggleARAgingModal}
        title={'Accounts Receivable'}
      />
    </>
  )
}

export default CollectionsBoard
